import Vue from 'vue'
import Constants from 'Constants'
import RootTiers from 'GroomyRoot/mixins/Tiers.js'

export default Vue.util.mergeOptions(RootTiers, {
    methods: {
        loadTiersLite: async function() {
			const url = Constants.TIERS_LITE_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_get_api("TiersMixin::loadTiersLite", url)
                .then(res => res.retour)
                    .catch(error => {
                        console.error("TiersMixin::loadTiersLite => ERROR", error)
                        return null
                    })
		},

        loadTiersWithCountry: async function() {
            const url = Constants.TIERS_LITE_COUNTRY_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_get_api("TiersMixin::loadTiersWithCountry", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::loadTiersWithCountry => ERROR", error)
                    return null
                })
        },

        loadCmepTiersWithCountry: async function(country_code = 75, postal_code = 0) {
            const params = {
                country_code: country_code,
                postal_code: postal_code
            }

            const url = this.constructRoute(Constants.TIERS_CMEP_LITE_COUNTRY_URL, params) + "?licence_key=" + Constants.USER_LICENCE_KEY

            return this.$request.request_get_api("TiersMixin::loadCmepTiersWithCountry", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::loadCmepTiersWithCountry => ERROR", error)
                    return null
                })
        },

        loadPostalCodesCmep: async function() {
            const url = this.constructRoute(Constants.TIERS_POSTAL_CODES_CMEP, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            return this.$request.request_get_api("TiersMixin::loadPostalCodesCmep", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::loadPostalCodesCmep => ERROR", error)
                    return null
                })
        },

        loadCountriesCmep: async function() {
            const url = this.constructRoute(Constants.TIERS_COUNTRIES_CMEP, {}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            return this.$request.request_get_api("TiersMixin::loadCountriesCmep", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::loadCountriesCmep => ERROR", error)
                    return null
                })
        },

        /**
         * Charge la liste des régions disponibles pour les CMEP d'un pays donné.
         * @param {number} country_code - Code pays interne (!=75)
         * @returns {Promise<string[]>} Liste des noms de régions, tableau vide en cas d'erreur
         */
        loadRegionsCmep: async function(country_code) {
            const url = this.constructRoute(Constants.TIERS_REGIONS_CMEP, { country_code }) + "?licence_key=" + Constants.USER_LICENCE_KEY

            return this.$request.request_get_api("TiersMixin::loadRegionsCmep", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::loadRegionsCmep => ERROR", error)
                    return []
                })
        },

		loadLoggedTiers: async function() {
			const url = Constants.TIERS_LOGGED_URL + "?licence_key=" + Constants.USER_LICENCE_KEY

            return this.$request.request_get_api("TiersMixin::loadLoggedTiers", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::loadLoggedTiers => ERROR", error)
                    return null
                })
		},

        /**
         * Met à jour les informations d'un tiers (adresse, TVA, civilité...).
         * Utilisé notamment lors de la complétion des données manquantes depuis InformationsTiersForm.
         * @param {Object} params - Données du tiers à mettre à jour (doit contenir tiers_id).
         * @returns {Object|null} Le tiers mis à jour, ou null en cas d'erreur.
         */
        editTiers: async function(params) {
            const url = this.constructRoute(Constants.TIERS_EDIT_URL, {tiers_id: params.tiers_id}) + "?licence_key=" + Constants.USER_LICENCE_KEY

            return this.$request.request_post_api("TiersMixin::editTiers", url, params, false)
                .then(res => res.retour)
                .catch(error => {
                    if (error.response && error.response.data) {
                        const code = error.response.data.code_retour
                        if (code === 'IF') return 'phone_invalid'
                        if (code === 'VA') return 'vat_duplicate'
                    }
                    console.error("TiersMixin::editTiers => ERROR", error)
                    return null
                })
        },

        /**
         * Vérifie si un SIRET est déjà associé à un tiers sur la licence.
         * @param {string} siret
         * @param {number} tiers_id - ID du tiers en cours d'édition (exclu de la recherche), 0 si création
         * @returns {{ exists: boolean, is_own_tiers: boolean, tiers_id: number|null }}
         */
        checkSiretOnLicence: async function(siret, tiers_id = 0) {
            const url = this.constructRoute(Constants.TIERS_CHECK_SIRET_URL, { siret, tiers_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_get_api("TiersMixin::checkSiretOnLicence", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::checkSiretOnLicence => ERROR", error)
                    return null
                })
        },

        /**
         * Vérifie si un numéro de TVA est déjà utilisé par un autre tiers sur la licence.
         * @param {string} vat_number
         * @param {number} tiers_id - ID du tiers en cours d'édition (exclu de la recherche)
         * @returns {{ exists: boolean, is_own_tiers: boolean, tiers_id: number|null }}
         */
        checkVatOnLicence: async function(vat_number, tiers_id) {
            const url = this.constructRoute(Constants.TIERS_CHECK_VAT_EXISTS_URL, { vat_number, tiers_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_get_api("TiersMixin::checkVatOnLicence", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::checkVatOnLicence => ERROR", error)
                    return null
                })
        },

        /**
         * Vérifie si un tiers a des contrats ou des factures existants.
         * @param {number} tiers_id
         * @returns {{ has_activities: boolean }|null}
         */
        checkTiersActivities: async function(tiers_id) {
            const url = this.constructRoute(Constants.TIERS_ACTIVITIES_URL, { tiers_id }) + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_get_api("TiersMixin::checkTiersActivities", url)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::checkTiersActivities => ERROR", error)
                    return null
                })
        },

        /**
         * Crée un nouveau tiers personne morale à partir des données Pappers,
         * rattaché à l'utilisateur connecté.
         * @param {Object} params - { siret, rs, address1, address2, postalcode, town, phone }
         * @returns {Object|null} Le tiers créé, ou null en cas d'erreur.
         */
        createTiersFromPappers: async function(params) {
            const url = Constants.TIERS_CREATE_FROM_PAPPERS_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_post_api("TiersMixin::createTiersFromPappers", url, params, false)
                .then(res => res.retour)
                .catch(error => {
                    console.error("TiersMixin::createTiersFromPappers => ERROR", error)
                    return null
                })
        },

        /**
         * Crée un nouveau tiers entreprise (hors France, hors Pappers).
         * @param {Object} params - { tiers_rs, tiers_address1, tiers_address2, tiers_postalcode, tiers_town, tiers_country, tiers_vat_number, phone, tiers_lang }
         * @returns {Object|'phone_invalid'|'vat_duplicate'|null}
         */
        createTiersEntreprise: async function(params) {
            const url = Constants.TIERS_CREATE_ENTREPRISE_URL + "?licence_key=" + Constants.USER_LICENCE_KEY
            return this.$request.request_post_api("TiersMixin::createTiersEntreprise", url, params, false)
                .then(res => res.retour)
                .catch(error => {
                    if (error.response && error.response.data) {
                        const code = error.response.data.code_retour
                        if (code === 'IF') return 'phone_invalid'
                        if (code === 'VA') return 'vat_duplicate'
                    }
                    console.error("TiersMixin::createTiersEntreprise => ERROR", error)
                    return null
                })
        },

        /**
         * Interroge l'API Pappers pour récupérer les informations d'une entreprise par SIRET.
         * @param {string} siret
         * @returns {Object|null} Le premier résultat Pappers, ou null si non trouvé / société inactive.
         */
        searchPappers: async function(siret) {
            const response = await fetch(
                `${Constants.PAPPERS_SUGGESTIONS_URL}?q=${encodeURIComponent(siret)}&cibles=siret`
            )
            if (!response.ok) throw new Error('HTTP ' + response.status)
            const data = await response.json()
            const results = Array.isArray(data.resultats_siret) ? data.resultats_siret : []
            if (results.length === 0 || results[0].date_cessation) return null
            return results[0]
        },

        getHorseTiersContacts: async function(horse_id) {
            let url = this.constructRoute(Constants.HORSE_TIERS_CONTACTS_URL, {horse_id}) + "?licence_key="+Constants.USER_LICENCE_KEY

            const result = await this.$request.request_get_api("Mouvement:getHorseTiersContacts", url)
            .catch(error => {
                console.error("MouvementMixin::getHorseTiersContacts => ERROR", error)
                return null
            })

            if(result && result.retour) return result.retour
            return null
        }
    }
})